import { axiosGet } from './service';

export async function getCMDefaultEarningScheme(currency) {
  return axiosGet('/api/Setting/CMDefaultEarningScheme',{Currency:currency});
}

export async function getLMDefaultEarningScheme(currency) {
  return axiosGet('/api/Setting/LMDefaultEarningScheme',{Currency:currency});
}

export async function getContactInfoByContactType(currency, contactTypeDescription = "") {
    return axiosGet('/api/Setting/GetContactInfo', { Currency: currency, contactTypeDescription: contactTypeDescription });
}

export async function getTransferLimitSettingByCurrency(currency) {
  return axiosGet('/api/Setting/GetTransferLimitSettingByCurrency', { Currency: currency });
}